module.exports = __webpack_public_path__ + "static/media/superior-dark.47d340e0.webp";